var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 262.37 262.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d62628;}.cls-2{fill:#fff;}.cls-3{fill:#231f20;}.cls-4{fill:#1d8bb2;}.cls-5{fill:#fff200;}.cls-6{fill:#ed1c24;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 131.18,
    cy: 131.18,
    r: 131.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 131.18,
    cy: 131.18,
    r: 94.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.21,175.34c4.75-1.93,16.75-8.47,18.89-10.25s-2.25-15-2.25-15-9.27-.06-12.84-.38-5.7-2-4.51-6.06,3.21-6.17,6.42-11.64c.31-.54-.42-1.66.17-3.56.92-3,4.47-3.34,5.71-2.91a5.14,5.14,0,0,1,3.44,4.15c.3,3-1.25,6.72-7.54,5.11a12.54,12.54,0,0,0-2.2,2.85c-.7,1.27-2.08,6.42-.18,6.54a74.21,74.21,0,0,0,13.55-.83c4-.83,1.3-2.14,1.3-2.14s-4.16-5,.12-9.74,9.27-.36,9.51,2.61,0,6.53-1.31,7.72,3.8-.35,3.8-.35,5.11-.72,7.49-2,2.49-2.5,4.75-2.86,5.3.14,4.12,1.57-2.1,1.35-4,1.7-9.21,5.24-10.64,6a6.3,6.3,0,0,0-3.08,5.41,37.6,37.6,0,0,0,1.24,13.25c1.67,6.06,2.26,10.4,1.55,14.11s-8.2,5-14.26,5H129.89l-1.42-3s16.63,0,20.32-2,1.66-4.85-.95-4.61-5.53-1.23-13,1.55-7.3,3.06-7.3,3.06l-1.38-3.27h0",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.19,149.05h18.18s8.2,55.6,57,87.33C175.4,236.38,117.66,220,100.19,149.05Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251,142.45s-18.89,7.12-26.37,31.36-14.22,63.45-41.33,72.36c0,0,13.7.57,26.18-11.22C239.74,199.49,224.59,173.81,251,142.45Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 85.48,
    cy: 233.78,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 178.95,
    cy: 233.78,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.5,263l-8.57,18.05L108,278.67l4.13-8c1.12-2.14,2.33-4.34,3.29-6l0,0C113.84,266,112,267.43,110,269l-7.16,5.49-2.9-2.36,4.15-8.14c1.08-2.07,2.13-4,3.24-5.83l0,0c-1.62,1.45-3.38,2.87-5.27,4.38L94.89,268l-2.81-2.28L108.4,254l2.94,2.39-4.22,8.36a57.53,57.53,0,0,1-3,5.45l0,0a60.76,60.76,0,0,1,4.88-4l7.52-5.66Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.63,247.1l4.77,5.55,4.32-3.72-5.34-6.2,2.22-1.9,7.64,8.89L89.53,262.38l-7.37-8.57,2.21-1.9,5.06,5.88,3.78-3.26L88.44,249Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.42,241.62a9.87,9.87,0,0,0-1.54-4.6c-1.24-1.89-2.83-2.37-4.15-1.5s-1.41,2.1-.81,4.64c.81,3.31.5,6-1.83,7.49-2.66,1.75-6.12.84-8.43-2.68a10.41,10.41,0,0,1-1.75-4.42l2.86-.86a8.26,8.26,0,0,0,1.35,3.75c1.24,1.88,2.77,2,3.72,1.4,1.24-.82,1.21-2.14.62-4.85-.78-3.53-.25-5.81,2.08-7.34,2.61-1.72,6.17-1.24,8.92,2.95a11.4,11.4,0,0,1,1.85,5.06Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.92,231.83l2.4,5-2.68,1.29-6.37-13.24L68,223.59l2.43,5,14.81-7.12,1.54,3.19Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.37,215.94a28.75,28.75,0,0,1-1.73-4.9c-.67-2.51-.76-4.17-.23-5.68a4.12,4.12,0,0,1,3-2.87,4.48,4.48,0,0,1,4.88,2l.07,0a4.91,4.91,0,0,1,3.64-5,5.12,5.12,0,0,1,4.35.77c1.51,1,2.67,3.08,3.58,6.52a34.79,34.79,0,0,1,.87,4.28Zm6.51-5.36-.47-1.76c-.63-2.38-2.1-3.4-3.68-3-1.77.47-2.22,2-1.65,4.17a9.75,9.75,0,0,0,.67,1.93Zm8.6-2.28a10.36,10.36,0,0,0-.38-1.84c-.58-2.19-1.93-4-4.24-3.34s-2.57,2.74-2,5.09l.45,1.71Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.39,186.64l.88,7.26,5.65-.69-1-8.12,2.89-.35,1.41,11.65L58,198.72,56.61,187.5l2.9-.35.93,7.69,5-.59L64.52,187Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.66,183.14l-19.41-.61.13-4.05,8.48-4.75a54.36,54.36,0,0,1,6.61-3.1l0-.07a79.11,79.11,0,0,1-8.05.06l-6.77-.21.1-3.27,19.41.6L76,171.41l-8.69,4.8a66.24,66.24,0,0,1-6.81,3.27l0,.09c2.52-.06,5.09,0,8.28.08l6.94.21Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.7,149.87a20,20,0,0,1-.2,6.34c-.66,3.21-2,5.49-4.06,6.93a9.7,9.7,0,0,1-7.53,1.24c-6-1.26-9-6.33-7.71-12.63a13.09,13.09,0,0,1,1.93-4.86l2.64,1.35a10.27,10.27,0,0,0-1.7,4.15c-.83,4.05,1,7.4,5.4,8.31s7.43-1.26,8.23-5.2a6.82,6.82,0,0,0,.16-2.7l-4.74-1-.69,3.35-2.73-.56,1.38-6.72Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.5,142.48,81,146l-1.32,3.42L63.84,136.61l1.63-4.21,20.38,1.12-1.37,3.55-5.75-.34ZM76,136.31l-5-.3c-1.25-.09-2.6-.26-3.76-.4l0,.06c1,.68,2.11,1.44,3.06,2.17L74.21,141Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.67,123l1.74-3.09L85.73,128l3.92-7,2.59,1.46-5.66,10Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.79,115a9.91,9.91,0,0,0,3.94-2.83c1.45-1.75,1.43-3.4.21-4.41s-2.42-.73-4.68.6c-2.91,1.75-5.54,2.23-7.69.46-2.45-2-2.6-5.6.08-8.84a10.19,10.19,0,0,1,3.7-3L90,99.51a8.42,8.42,0,0,0-3.18,2.41c-1.44,1.73-1.12,3.23-.24,4,1.15,1,2.4.53,4.81-.84,3.14-1.78,5.48-2,7.63-.18,2.41,2,3,5.53-.19,9.39a11.44,11.44,0,0,1-4.29,3.26Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.11,92.54l-4.06,3.78-2-2.19,10.76-10,2,2.18-4.1,3.81,11.18,12-2.6,2.42Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113,92.45l1.85,5.43-3,2.13L105.61,80.6,109.29,78l16.43,12.1-3.09,2.22L118,88.86ZM116,87l-4-3c-1-.76-2-1.64-2.93-2.39l-.06,0c.44,1.09,1,2.35,1.37,3.49l1.58,4.77Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.42,74.54l-4.87,2.64-1.42-2.62,12.92-7,1.41,2.63-4.92,2.66,7.82,14.45L128.24,89Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.18,72.52l-6.84,2.59,2,5.33,7.65-2.9,1,2.72-11,4.16-6.89-18.14,10.56-4,1,2.73-7.25,2.75,1.77,4.67,6.84-2.6Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.68,58.71l1.26,7.66L164,65l-1.25-7.66,3.5-.58L169.42,76l-3.5.58-1.39-8.46-8.09,1.33,1.38,8.46-3.5.57-3.14-19.16Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.82,70.34l-1.68,5.48h-3.67l6.32-19.39,4.52,0,6.21,19.45-3.81,0L182,70.37Zm5.59-2.65-1.5-4.79c-.37-1.2-.69-2.53-1-3.65h-.07c-.28,1.13-.59,2.48-.94,3.63l-1.52,4.79Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.61,76l3.31-19.12,4,.69,3.52,9.06a53.32,53.32,0,0,1,2.15,7h.07a79.24,79.24,0,0,1,1.06-8L203.86,59l3.23.56-3.31,19.12L200.16,78l-3.53-9.27a67.26,67.26,0,0,1-2.29-7.19h-.09c-.29,2.51-.68,5-1.23,8.18l-1.18,6.84Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.67,61.29a37.35,37.35,0,0,1,5.47,1.53c3.42,1.23,5.5,2.78,6.68,4.79a8.72,8.72,0,0,1,.44,7.75,10.05,10.05,0,0,1-5.47,6.24c-2.42,1-5.61.78-9.16-.5a39.1,39.1,0,0,1-4.42-1.86ZM210.43,78a14.14,14.14,0,0,0,1.83.76c4.32,1.58,7.77.11,9.43-4.52,1.47-4,0-7.17-4.2-8.68a11.79,11.79,0,0,0-2.35-.63Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.4,69a28.74,28.74,0,0,1,4.72,2.15c2.28,1.26,3.54,2.35,4.26,3.77a4.17,4.17,0,0,1,0,4.17,4.45,4.45,0,0,1-4.85,2.08l0,.07a4.9,4.9,0,0,1,1.1,6.11A5.12,5.12,0,0,1,234,90c-1.79.37-4.07-.21-7.18-1.94a35.6,35.6,0,0,1-3.69-2.34Zm-5,16.18a10.5,10.5,0,0,0,1.59,1c2,1.11,4.18,1.35,5.34-.74s-.19-3.75-2.31-4.93l-1.54-.86Zm4.33-7.77,1.58.88c2.15,1.19,3.91.85,4.71-.59s.08-3-1.87-4.08a9.45,9.45,0,0,0-1.85-.85Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.56,91.19l-4.68,3.31L235,92.24l16.86-11.47,3.56,2.78-7,19.18-3-2.34,2-5.41Zm6.05,1.32,1.74-4.71c.45-1.18,1-2.42,1.47-3.49l0,0c-.93.73-2,1.6-3,2.3l-4.13,2.86Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.2,90.3l2.46,2.57L253.8,104.24l5.52,5.77-2.15,2.06-8-8.33Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.48,101.48l2.13,2.84-13.17,9.84,4.77,6.39-2.38,1.78-6.9-9.23Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.7,128.63l-5.66.9-1.6-3.3,20.18-2.84,2,4.06-14.72,14.13-1.66-3.43,4.17-4Zm4.84,3.86,3.64-3.46c.92-.86,2-1.72,2.85-2.48l0,0c-1.14.24-2.48.55-3.67.75l-5,.74Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.78,141.6a9.75,9.75,0,0,0,.21,4.84c.67,2.16,2.06,3.06,3.58,2.59s1.93-1.63,2.05-4.24c.14-3.4,1.17-5.87,3.83-6.7,3-.94,6.11.89,7.36,4.91a10.35,10.35,0,0,1,.46,4.73l-3,0a8.46,8.46,0,0,0-.27-4c-.67-2.15-2.1-2.71-3.19-2.37-1.42.44-1.75,1.72-1.93,4.49-.23,3.6-1.36,5.65-4,6.48-3,.93-6.27-.51-7.76-5.29a11.36,11.36,0,0,1-.38-5.38Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.76,155.05a9.87,9.87,0,0,0-.43,4.84c.39,2.23,1.65,3.29,3.21,3s2.13-1.37,2.6-3.94c.58-3.35,1.92-5.66,4.67-6.13,3.13-.54,5.94,1.67,6.65,5.82a10.17,10.17,0,0,1-.16,4.75l-3-.35a8.43,8.43,0,0,0,.25-4c-.38-2.21-1.72-3-2.84-2.76-1.47.25-2,1.48-2.51,4.2-.7,3.54-2.09,5.42-4.84,5.9-3.08.53-6.15-1.34-7-6.27a11.26,11.26,0,0,1,.32-5.38Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.38,186.08c-6.5.09-10.27-3.79-10.35-9.14s4.06-9,9.75-9.1c6-.08,10.22,3.62,10.3,9.1C301.16,182.6,296.93,186,291.38,186.08Zm-.48-14.49c-4,0-7.08,2.1-7,5.49s3.27,5.32,7.33,5.26c3.66-.06,7.09-1.92,7-5.46S294.89,171.53,290.9,171.59Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.64,201.53a12.51,12.51,0,0,1-.12-5.11c.93-6.09,5.31-9.22,11.16-8.34,6.31,1,9.45,5.95,8.56,11.81a10.84,10.84,0,0,1-1.55,4.52L295,203.23a9.28,9.28,0,0,0,1.32-3.63c.59-3.91-1.42-7.1-6-7.8-4.23-.64-7.28,1.42-7.92,5.64a10.28,10.28,0,0,0,.12,3.93Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296.31,211.39l-18.78-4.92.9-3.43L297.21,208Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.69,214.77l-4.52-3.52,1.32-3.42,15.85,12.82-1.63,4.21-20.38-1.13,1.38-3.55,5.75.34Zm.48,6.17,5,.31c1.25.08,2.6.26,3.76.39l0-.06c-1-.67-2.11-1.43-3.06-2.17L283,216.28Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.28,233.8l2.63-4.87,2.62,1.42-7,12.91-2.61-1.42,2.66-4.92-14.45-7.82,1.69-3.12Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.82,248.52l-16.07-10.87,2-2.94,16.07,10.88Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.52,259.51c-4.89-4.28-5.1-9.69-1.58-13.72s9.05-4,13.33-.25c4.48,3.92,5.18,9.53,1.57,13.65S261.7,263.16,257.52,259.51Zm9.34-11.1c-3-2.6-6.67-3.17-8.9-.62s-1.13,6.14,1.93,8.81c2.76,2.41,6.56,3.32,8.88.65S269.86,251,266.86,248.41Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249,253.89,261.1,269l-3.16,2.54-9.13-3.36a56.41,56.41,0,0,1-6.64-3l0,.06c1.81,1.85,3.43,3.76,5.29,6.07l4.23,5.29-2.55,2.05-12.15-15.14,2.87-2.3,9.29,3.49a68.2,68.2,0,0,1,6.91,3l.05-.08c-1.68-1.87-3.32-3.85-5.32-6.33l-4.34-5.42Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156.93,283.47h-.05l-3.69,1-.09-2.75,4.92-1.32,2.9.57-3.62,18.37-3.36-.67Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.07,298.1a10.35,10.35,0,0,0,2,.08,7.09,7.09,0,0,0,3.88-1.2,6.71,6.71,0,0,0,2.66-4l-.07,0a5.14,5.14,0,0,1-4.16,1.39,5.52,5.52,0,0,1-5.31-6.13,6.62,6.62,0,0,1,7.16-6.26c4.36.27,6.46,3.83,6.17,8.39-.25,4-1.73,6.75-3.8,8.47A10.24,10.24,0,0,1,168,301a13.76,13.76,0,0,1-2.13-.07Zm2.49-9.88c-.12,1.93.9,3.5,2.86,3.63a3.45,3.45,0,0,0,3.1-1.37,2.12,2.12,0,0,0,.27-1c.18-2.53-.64-4.75-2.93-4.89C170.08,284.46,168.69,286,168.56,288.22Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.26,281.78l.16,2.26-6.76,17-3.72.26L188.72,285V285l-8.82.62-.2-2.93Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.88,296.28a9.51,9.51,0,0,0,4.41.28c2.65-.55,3.41-2.26,3.11-3.7-.46-2.16-2.69-2.68-4.81-2.26l-1.58.33-.52-2.53,1.55-.32c1.6-.33,3.47-1.47,3.1-3.29-.26-1.27-1.38-2.11-3.4-1.7a7.56,7.56,0,0,0-3.52,1.91l-1.3-2.34a10.33,10.33,0,0,1,5-2.49c3.79-.77,6.15.93,6.63,3.33.39,1.91-.41,3.71-2.49,5v.06a4.74,4.74,0,0,1,5,3.75c.63,3.1-1.47,6.09-6,7a10.22,10.22,0,0,1-5.39-.22Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226.85,150.09S213.06,152,206.77,169c-8.16,22-3.57,24.09-10.1,38.11,0,0,9.41-3.57,13.35-11.41C215.6,184.58,215.32,162.45,226.85,150.09Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.73,150.09S196,152,189.65,169c-8.16,22-3.56,24.09-10.1,38.11,0,0,9.42-3.57,13.35-11.41C198.49,184.58,198.21,162.45,209.73,150.09Z",
    transform: "translate(-47.42 -47.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.15,150.08S178.37,152,172.07,169c-8.16,22-3.56,24.09-10.1,38.11,0,0,9.42-3.57,13.36-11.41C180.91,184.57,180.63,162.44,192.15,150.08Z",
    transform: "translate(-47.42 -47.41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9a70e90d218968634537120fa7db81e4.svg";
export { ForwardRef as ReactComponent };